// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCXXwEwz0_vc2CGx9-oUbw5zKGy6Ch437k",
    authDomain: "local-eats-user.firebaseapp.com",
    databaseURL: "https://local-eats-user.firebaseio.com",
    projectId: "local-eats-user",
    storageBucket: "local-eats-user.appspot.com",
    messagingSenderId: "356815131138",
    appId: "1:356815131138:web:b39607bc4f0d8f9882cd1b",
    measurementId: "G-JY12FJ6PQC"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
